import { Component, computed, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatListItem, MatListItemIcon, MatNavList } from '@angular/material/list';
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { MatToolbar } from '@angular/material/toolbar';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { CdnModule } from '@psu-pennstateit-swe/utils/cdn';
import { ScreenSizeService } from '@psu-pennstateit-swe/utils/responsive';
import { FortressSearchComponent } from '../fortress-search/fortress-search.component';
import { RoutePaths } from '../route-paths.model';

@Component({
  selector: 'app-fortress',
  imports: [
    CdnModule,
    MatIcon,
    MatIconButton,
    MatListItem,
    MatListItemIcon,
    MatNavList,
    MatSidenav,
    MatSidenavContainer,
    MatSidenavContent,
    MatToolbar,
    RouterLinkActive,
    RouterOutlet,
    RouterLink,
    FortressSearchComponent,
  ],
  templateUrl: './fortress.component.html',
  styleUrl: './fortress.component.scss',
})
export class FortressComponent {
  isHandsetAndPortrait = computed(() => this.screenSizeService.isHandset() && this.screenSizeService.isPortrait());
  brandMark = computed(() => {
    if (!this.isHandsetAndPortrait()) {
      return 'img/PSU_HOR_RGB_2C.svg';
    } else {
      return 'img/PSU_RGB_2C.png';
    }
  });

  menuItems = [
    {
      label: 'Roles',
      routerLink: RoutePaths.Roles,
      icon: 'account-cog',
    },
  ];

  private screenSizeService = inject(ScreenSizeService);
}
